import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { FinanceServicesService } from 'src/app/services/finance-services.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company-finance-details',
  templateUrl: './company-finance-details.component.html',
  styleUrls: ['./company-finance-details.component.css']
})
export class CompanyFinanceDetailsComponent implements OnInit {
  
  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  financialList: any[];
  financialYears: any[];
  companyID: any;
  companyName: any;

  constructor(private financeServiceRelatedCompany: FinanceServicesService, private router: Router,
    private commonFunction: CommonFunction,private route: ActivatedRoute) {

  }

  /**
   * get financial data related company
   */
  getFinancialListRelatedCompany() {

    
    this.financeServiceRelatedCompany.financeDataRelatedCompany()
      .subscribe(financialList => {
        if (financialList.status == 0) {
          this.financialList = financialList.financialData;
          console.log(" this.financialList", this.financialList);
          this.dtTrigger.next();
        }
      });
  }

  /**
   * get financial by comapanyId and route edit page
   */
  loadFinanceDetailsById(id,year) {
    
    
    localStorage.setItem('financeyear',year);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['company', 'financeDetails','edit',id]  } }],
      { relativeTo: this.route.parent });
  }

  /**
 * add new financial data related company
 */
  addNewFinancialData() {
    var companyId = localStorage.getItem('companyId');
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['company', 'financeDetails','add']  } }],
      { relativeTo: this.route.parent });
  }

  setCompnayDetails() {
    var loginUsers = JSON.parse(localStorage.getItem('companyDetails'));

    this.companyID = loginUsers.companyID;
    this.companyName = loginUsers.companyName;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    
    this.commonFunction.validateURL('CompanyFinancialDetails', '');
    this.getFinancialListRelatedCompany();

    this.setCompnayDetails();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'desc'],
      columnDefs: [{ orderable: false, targets: [3] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Financial Data List',
          title: 'Financial Data List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

  }

}

